import type { MutableRefObject, ReactNode } from "react";

import type { Optional } from "../../../types/react";

export enum StatusEnum {
    ENTER_ACTIVE = "enterActive", // анимация появления (isShow = true)
    ENTER_DONE = "enterDone", // анимация появления отработала  (isShow = true)
    EXIT_ACTIVE = "exitActive", // анимация ухода  (isShow = false)
    EXIT_DONE = "exitDone", // анимация ухода отработала, убираем children из DOM (isShow = false)
}

export interface ITransitionProps {
    // элемент, к которому будут добавляться классы для анимации
    refElement: MutableRefObject<HTMLElement | null>;
    // длительность анимации (вместе с задержкой, если она есть)
    timeout: number;
    // если время анимации "ухода" отличается от анимации "появления"
    timeoutForExit?: number;
    // названия классов, которые будут добавляться/убираться в зависимости от статуса компонента
    classes: Optional<Record<StatusEnum, string>, StatusEnum.EXIT_DONE>;
    // параметр, при изменении которого будет меняться статус компонента
    isShow: boolean;
    // если нужно пропустить анимацию для первого рендера, задаем true
    skipFirstRender?: boolean;
    // callback, который вызывается на статусе StatusEnum.ENTER_DONE
    onEntered?: () => void;
    // callback, который вызывается на статусе StatusEnum.EXIT_DONE
    onExited?: () => void;
    // элемент всегда находится в ДОМе
    alwaysInDOM?: boolean;
    // помещаем то, что необходимо показать/скрыть
    children: ReactNode;
}
